import React from "react";
import BelieveCard from "./BelieveCard";

function BelieveSection() {
  const data = [
    {
      headingText: "What is the RichApeGang?",

      text: "Each Rich Ape NFT is stored as ERC-721 tokens on the Ethereum blockchain and hosted on IPFS.",
    },
    {
      headingText: "What will the mint price be?",

      text: "We want to provide our community with the best quality art for an affordable price. That is why we chose a mint price of 0.085 ETH (+ gas fees).",
    },
    {
      headingText: "How can I use my NFT?",

      text: "Apart from it being the sassiest PFF, you will be able to use your Rich Apes as an avatar in the Metaverse. As well as using it to unlock various members-only benefits",
    },
  ];
  return (
    <div className="BelieveSection" id="faq">
      <div className="container">
        <div className="believeInfo text-center">
          <h1 className="sectionHeading mb-5">
            <span>FAQs</span>
          </h1>
        </div>
        <div className="row">
          {data.map((item) => (
            <div className="col-lg-4">
              <div className="px-md-5 px-lg-0 py-4 py-lg-0">
                <BelieveCard data={item} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default BelieveSection;
